module.exports = __webpack_public_path__ + "584bcd52af08630a904e123ccb3b6f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/AnimaReal_Grey2x.png
// module id = 107
// module chunks = 0